export const GET_ALL_INVOICES = 'GET_ALL_INVOICES';
export const SET_ALL_INVOICES = 'SET_ALL_INVOICES';
export const SET_SIMPLE_INVOICE_DATA = 'SET_SIMPLE_INVOICE_DATA';

export const CREATE_SIMPLE_INVOICE = 'CREATE_SIMPLE_INVOICE';

export const SET_CREATED_SIMPLE_INVOICE = 'SET_CREATED_SIMPLE_INVOICE';

export const SET_EDIT_INVOICE_DATA = 'SET_EDIT_INVOICE_DATA';

export const DELETE_INVOICE = 'DELETE_INVOICE';
export const GET_SINGLE_INVOICE = 'GET_SINGLE_INVOICE';

export const DOWNLOAD_INVOICE_CSV = 'DOWNLOAD_INVOICE_CSV';
export const DOWNLOAD_INVOICE_CSV_FAILURE = 'DOWNLOAD_INVOICE_CSV_FAILURE';
export const DOWNLOAD_INVOICE_CSV_SUCCESS = 'DOWNLOAD_INVOICE_CSV_SUCCESS';
